import { render, staticRenderFns } from "./PlayerUnbanLink.vue?vue&type=template&id=7a8ff319&"
import script from "./PlayerUnbanLink.vue?vue&type=script&lang=js&"
export * from "./PlayerUnbanLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports